export const commonDe = {
  nav: {
    story: 'Unsere Geschichte',
    community: 'Gemeinschaft',
    transformation: 'Transformation',
    safety: 'Sicherheit',
    blog: 'Blog',
    shop: 'Shop',
    donate: 'Unterstützen',
    volunteer: 'Freiwillig',
    resources: 'Ressourcen',
    crisisTracker: 'Krisenverfolger',
    partners: 'Partner',
    successStories: 'Erfolgsgeschichten',
  },
  // Navigation
  home: "Startseite",
  myStory: "Meine Geschichte",
  community: "Gemeinschaft",
  shop: "Shop",
  blog: "Blog",
  
  // Common buttons
  readMore: "Mehr Lesen",
  learnMore: "Mehr Erfahren",
  joinNow: "Jetzt Beitreten",
  shopNow: "Jetzt Kaufen",
  subscribe: "Abonnieren",
  submit: "Senden",
  
  // Footer
  quickLinks: "Schnelllinks",
  contact: "Kontakt",
  followUs: "Folgen Sie uns",
  allRightsReserved: "Alle Rechte vorbehalten",
  
  // Newsletter
  newsletterTitle: "Treten Sie Unserer Gemeinschaft Bei",
  newsletterSubtitle: "Erhalten Sie wöchentliche Inspiration und Updates in Ihrem Posteingang",
  emailPlaceholder: "E-Mail eingeben",
  
  // Common phrases
  byAuthor: "Von"
};

export default commonDe;
